// lib/mock/coupons.ts
import type { Coupon } from "@/types";

export const MOCK_COUPONS: Coupon[] = [
  {
    id: 1,
    code: "SUMMER20",
    percent: 20,
    maxUsage: 100,
    usedCount: 45,
    status: "active",
    expiresAt: Date.now() + 30 * 86400000,
    createdAt: Date.now() - 10 * 86400000,
  },
  {
    id: 2,
    code: "WELCOME10",
    percent: 10,
    maxUsage: 500,
    usedCount: 312,
    status: "active",
    expiresAt: Date.now() + 60 * 86400000,
    createdAt: Date.now() - 30 * 86400000,
  },
  {
    id: 3,
    code: "VIP30",
    percent: 30,
    maxUsage: 50,
    usedCount: 50,
    status: "expired",
    expiresAt: Date.now() - 5 * 86400000,
    createdAt: Date.now() - 60 * 86400000,
  },
  {
    id: 4,
    code: "NOWRUZ15",
    percent: 15,
    maxUsage: 200,
    usedCount: 88,
    status: "active",
    expiresAt: Date.now() + 15 * 86400000,
    createdAt: Date.now() - 5 * 86400000,
  },
  {
    id: 5,
    code: "DISABLED5",
    percent: 5,
    maxUsage: 100,
    usedCount: 0,
    status: "disabled",
    expiresAt: Date.now() + 90 * 86400000,
    createdAt: Date.now() - 2 * 86400000,
  },
];